import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import ToolPicker from "@/components/ToolPicker.svelte";
import ColorPicker from "@/components/ColorPicker.svelte";
import MarkerActions from "@/components/MarkerActions.svelte";
import MapControls from "@/components/MapControls.svelte";
import LayerToggles from "@/components/LayerToggles.svelte";
import { markerStore } from "@/stores/markers.svelte";

var root = $.from_html(`<aside class="sidebar svelte-2f63upinvk5nv"><header class="sidebar-header svelte-2f63upinvk5nv"><h1 class="logo svelte-2f63upinvk5nv">OSRS Tile Editor</h1></header> <div class="sidebar-scroll svelte-2f63upinvk5nv"><section class="panel svelte-2f63upinvk5nv"><!></section> <hr class="divider svelte-2f63upinvk5nv"/> <section class="panel svelte-2f63upinvk5nv"><!></section> <hr class="divider svelte-2f63upinvk5nv"/> <section class="panel svelte-2f63upinvk5nv"><!></section> <section class="panel svelte-2f63upinvk5nv"><!></section> <hr class="divider svelte-2f63upinvk5nv"/> <section class="panel svelte-2f63upinvk5nv"><div class="marker-count svelte-2f63upinvk5nv"><span class="count-num svelte-2f63upinvk5nv"> </span> <span class="count-label svelte-2f63upinvk5nv"> </span></div></section> <section class="panel svelte-2f63upinvk5nv"><!></section></div> <footer class="sidebar-footer svelte-2f63upinvk5nv">Made with ❤ by <a href="https://github.com/Chumbus/osrs-map-tile-editor" target="_blank" rel="noopener" class="svelte-2f63upinvk5nv">Ben Knowles</a></footer></aside>`);

function Sidebar($$anchor, $$props) {
	$.push($$props, false);
	$.init();

	var aside = root();
	var div = $.sibling($.child(aside), 2);
	var section = $.child(div);
	var node = $.child(section);

	MapControls(node, {});
	$.reset(section);

	var section_1 = $.sibling(section, 4);
	var node_1 = $.child(section_1);

	LayerToggles(node_1, {});
	$.reset(section_1);

	var section_2 = $.sibling(section_1, 4);
	var node_2 = $.child(section_2);

	ToolPicker(node_2, {});
	$.reset(section_2);

	var section_3 = $.sibling(section_2, 2);
	var node_3 = $.child(section_3);

	ColorPicker(node_3, {});
	$.reset(section_3);

	var section_4 = $.sibling(section_3, 4);
	var div_1 = $.child(section_4);
	var span = $.child(div_1);
	var text = $.child(span, true);

	$.reset(span);

	var span_1 = $.sibling(span, 2);
	var text_1 = $.child(span_1, true);

	$.reset(span_1);
	$.reset(div_1);
	$.reset(section_4);

	var section_5 = $.sibling(section_4, 2);
	var node_4 = $.child(section_5);

	MarkerActions(node_4, {});
	$.reset(section_5);
	$.reset(div);
	$.next(2);
	$.reset(aside);

	$.template_effect(() => {
		$.set_text(text, markerStore.count);
		$.set_text(text_1, markerStore.count === 1 ? "marker" : "markers");
	});

	$.append($$anchor, aside);
	$.pop();
}

if (import.meta.hot) {
	Sidebar = $.hmr(Sidebar);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-2f63upinvk5nv');
		Sidebar[$.HMR].update(module.default);
	});
}

export default Sidebar;
import "bun-svelte:Sidebar.svelte-1zxf2hox7i6iw-style.css";